<template>
  <section id="admin-filter">
    <h4>Point To Port filter</h4>
    <div class="form-group">
      <label class="form-label">Origin Point</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Origin Point"
        placeHolder="Type to search"
        :initVal="entity.originPoint"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label class="form-label">Destination Point</label>
      <autocomplete
        :dataset="locationSearchResults"
        title="Destination Point"
        placeHolder="Type to search"
        :initVal="entity.destinationPoint"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectDestination"
      ></autocomplete>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'PointToPortFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          originPoint: '',
          destinationPoint: ''
        }
      }
    },
    components: {
      Autocomplete
    },
    methods: {
      selectOrigin (o) {
        this.entity.originPoint = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationPoint = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// PointToPortFilter.vue?ec5a043c